import { render, staticRenderFns } from "./CredentialGating.vue?vue&type=template&id=50d68784&scoped=true&"
import script from "./CredentialGating.vue?vue&type=script&lang=js&"
export * from "./CredentialGating.vue?vue&type=script&lang=js&"
import style0 from "./CredentialGating.vue?vue&type=style&index=0&id=50d68784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d68784",
  null
  
)

export default component.exports